module.exports = __webpack_public_path__ + "static/media/moon.80e0ee14.jpg";